import type { SimpleDataTableColumn, SimpleDataTableRow } from '../components/Tables/SimpleDataTable/SimpleDataTable';
import type { ResultTableRow, RecommendationProductRow } from '../types';

export const RESULT_TABLE_COLUMNS: SimpleDataTableColumn[] = [
	{ key: 'param', label: 'PARÂMETRO', emphasis: 'strong' },
	{ key: 'unit', label: 'UNIDADE' },
	{ key: 'current', label: 'SITUAÇÃO ATUAL' },
	{ key: 'range', label: 'FAIXA ADEQUADA' },
	{ key: 'after', label: 'APÓS A CORREÇÃO (ESTIMADO)' },
];

export const mapResultTableRows = (rows: ResultTableRow[]): SimpleDataTableRow[] =>
	rows.map((row, index) => ({
		id: `${row.param}-${index}`,
		cells: {
			param: row.param,
			unit: row.unit,
			current: row.current,
			range: row.range,
			after: row.after,
		},
	}));

export const PRODUCT_TABLE_COLUMNS: SimpleDataTableColumn[] = [
	{ key: 'product', label: 'PRODUTO', emphasis: 'strong' },
	{ key: 'dose', label: 'DOSE POR HA (KG)' },
	{ key: 'forma', label: 'FORMA DE APLICAÇÃO' },
];

export const mapProductTableRows = (rows: RecommendationProductRow[]): SimpleDataTableRow[] =>
	rows.map((row, index) => ({
		id: `${row.product}-${index}`,
		cells: {
			product: row.product || '—',
			dose: row.dose || '—',
			forma: row.forma || '—',
		},
	}));
